<template>
  <div class="mylocal-tooltip" v-if="!isPrefAvailable">
    Localise your news settings here
  </div>
</template>

<script>
export default {
  name: 'ToolTip',
  props: {
    isPrefAvailable: Boolean
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.mylocal-tooltip {
  visibility: visible;
  width: 200px;
  background-color: $c-button-blue;
  color: #fff;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: 50px;
  right: 5px;
  margin-left: -60px;
  font-size: 16px;
  font-weight: bold;

  &:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 70%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent $c-button-blue transparent;
  }
}
</style>